import { connect } from 'react-redux';
import { SkMaxPrice } from '~/Api/User/ProductGroup/SkMaxPrice';
import { formatPercentage } from '~/utils/Intl';
import { ProductValues } from '../ProductsTable/ProductsTable';

import Calculation from './Calculation';

interface OwnProps {
	skMaxPrice: SkMaxPrice;
	productValues: { [id: string]: ProductValues };
	referencePackageSize: number | null;
}

function mapStateToProps(_: Record<never, never>, props: OwnProps) {
	return {
		formatPercentage,
	};
}

export default connect(mapStateToProps)(Calculation);
